<!-- 
    FORM PARA INCLUSAO DE NEGOCIOS
-->

<script>
import Vue from 'vue';
import { SysVars } from '../main';
import { apiORDSpost, apiORDS } from '../shared/api-functions'
import InputColor from '../components/input-color'
import CrmPipeline from './crm-pipeline'
import CrmTagForm from './crm-tag-form'
import CrmNegocioMotivoForm from './crm-negocio-motivo-form'
import apiCrm from '../api/api-crm.js'

export default {
    props: {
        funil: {},
        params: {},
    },
    
    components: {
        InputColor, CrmPipeline, CrmTagForm, CrmNegocioMotivoForm,
    },

    data () {
        return {
            errmessages: null,
            metadata: this.$store.getters.getEntities.metadata,

            localFunil: null,

            negociocrm: {...this.$store.getters.getEntities.negociocrm},
            pessoa: {},
            organizacao: {},
            origem: {},

            telefones: [],
            emails: [],

            showTagForm: false,
            codtag: null,
            crudTag: '',

            inputOrg: {
                url: '/crm/find/organizacao?nome=',
                permite_novo: true,
                codigo: null,
                // label: 'Organização',
                icon: 'fa-university', 
                // placeholder: 'Nome da Organização',
            },

            inputPessoa: {
                url: '/crm/find/pessoa?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user', 
            },            

            inputOrigem: {
                url: '/crm/find/origem?nome=',
                permite_novo: true,
                codigo: null,
                icon: 'fa-user', 
            },            

            inputFone: {
                url: '/crm/find/pessoa?fone=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.fonecrm.numero.label,
            },           

            inputEmail: {
                url: '/crm/find/pessoa?email=',
                duplicados: true,
                codigo: null,
                // label: this.$store.getters.getEntities.metadata.emailcrm.email.label,
            },           

        }
    },

    mixins: [apiCrm],  //ROTINAS DO CRM

    computed: {
        // nome: function () {
            // return this.pessoacrm.nome
        // }
        administrador: function () {
            return SysVars.usuarioAdministrador
        },

        isNovoNegocio: function () {
            return !this.params || !this.params.negocio
        },

        alterarOutrosCampos: function () {
            return this.isNovoNegocio || this.params.alterarOutrosCampos
        },

        alterarPessoa: function () {
            return this.params.alterarPessoa
        },

        alterarOrg: function () {
            return this.params.alterarOrg
        },

        habilitaContatos: function () {
            return this.pessoa && this.pessoa.novo
        },

        title: function () {
            if (this.negociocrm.codnegocio)
              return 'Alterar Negócio'
            else
              return 'Incluir Novo Negócio'
        },

    },

    methods: {
        handleCadastroOrigem () {
            this.$router.push('/crm/config')
        },

        handleSalvar () {
            var valido = true;

            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Corrija os erros de preenchimento para continuar!')
                } else if (valido) {
                    this.pessoa.telefones = this.telefones
                    this.pessoa.emails = this.emails
                    this.organizacao.endereco = null
                    this.organizacao.codtag = null
                    this.organizacao.visivel = null
                    this.negociocrm.dados = { 
                        org: this.organizacao,
                        pessoa: this.pessoa
                    }
                    this.apiNegocio(this.negociocrm, this.negociocrm.codnegocio, this.callBackPost)
                }
            })

        },

        callBackPost (negocio) {
            if (this.negociocrm.codnegocio)
                this.$erpToastSuccess('Negócio alterado')
            else
                this.$erpToastSuccess('Novo negócio criado')
            this.closeForm(negocio)
        },

        closeForm (negocio) {
            this.$emit('closeform', negocio)
        },

        handleNovoOrg (text) {
            this.organizacao = { novo: true, nome: text }
        },

        handleNovoPessoa (text) {
            this.pessoa = {
                novo: true,
                nome: text,
            }
            this.telefones = []
            this.emails = []
            this.handleAdicionarEmail()
            this.handleAdicionarTelefone()
        },

        handleNovoOrigem (text) {
            this.origem = { novo: true, nome: text }
        },

        handleSelectOrg (selected) {
            this.organizacao = selected
            if (this.organizacao) {
                this.organizacao.novo = false
            }
        },

        handleSelectPessoa (selected) {
            this.pessoa = selected
            if (this.pessoa) {
                this.pessoa.novo = false
                this.telefones = this.pessoa.telefones
                this.emails = this.pessoa.emails
                if (this.pessoa.codorg) {
                    this.negociocrm.codorg = this.pessoa.codorg
                    this.organizacao.codorg = this.pessoa.codorg
                    this.organizacao.nome = this.pessoa.nome_org
                    this.organizacao.novo = false
                    this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
                }
            }
        },

        handleSelectOrigem (selected) {
            this.origem = selected
            if (this.origem) {
                this.origem.novo = false
            }
        },

        handleChangeEtapa (etapa) {
            this.negociocrm.codetapa = etapa.codetapa
        },

        setFields () {
            //OS CAMPOS DE NOME DA PESSOA E ORGANIZACAO DEVEM RECEBER OS RESPECTIVOS VALORES
            if (this.negociocrm.codorigem && this.$refs.origem) {
                this.origem = this.negociocrm.origem[0]
                this.origem.novo = false
                this.$refs.origem.setValue(this.origem.codorigem, this.origem.descricao, this.origem)
            }
            console.log(this.pessoa)
            if (this.params && this.params.lead) {
                this.$refs.pessoa.setValue(this.pessoa.codpessoa, this.pessoa.nome, this.pessoa)
                this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
            } else {
                if (this.negociocrm.codpessoa && this.$refs.pessoa) {
                    this.pessoa = this.negociocrm.pessoa[0]
                    this.pessoa.novo = false
                    this.telefones = this.pessoa.telefones
                    this.emails = this.pessoa.emails
                    this.$refs.pessoa.setValue(this.pessoa.codpessoa, this.pessoa.nome, this.pessoa)
                }
                if (this.negociocrm.codorg && this.$refs.organizacao) {
                    this.organizacao = this.negociocrm.organizacao[0]
                    this.organizacao.novo = false
                    this.$refs.organizacao.setValue(this.organizacao.codorg, this.organizacao.nome, this.organizacao)
                }
            }
        },

        // async loadData (id) {
        //     await this.$store.dispatch('loadNegocio', { id: this.index } )
        //     if (this.$store.getters.getNegocio) {
        //         this.negocio = {...this.$store.getters.getNegocio}
        //     }
        // },

        /////////////////////////////////// TELEFONES

        handleAdicionarTelefone () {
            this.telefones.push({
                numero: null,
                ramal: null,
                tipofone: '0'
            })
        },

        handleDeleteTelefone (index) {
            this.telefones.splice(index,1)
        },

        /////////////////////////////////// EMAILS
        handleAdicionarEmail() {
            this.emails.push({
                email: null,
                tipoemail: null
            })
        },

        handleDeleteEmail (index) {
            this.emails.splice(index,1)
        },



        //////////////////////////// TAG FORM
        handleAdicionarTag () {
            this.codtag = null
            this.crudTag = SysVars.crudI
            this.showTagForm = true
        },

        handleEditarTag (cod) {
            this.crudTag = SysVars.crudU
            this.codtag = cod
            this.showTagForm = true
        },

        handleCloseTag (tag) {
            this.$refs.etiqueta.loadData()
            this.showTagForm = false
            if (tag) {
                this.negociocrm.codtag = tag.codtag
            }
        },

        async loadConfig () {
            await this.$store.dispatch('loadConfigCrm', this)

            this.localFunil = this.$store.getters.getConfigCrm.funil[0]
            this.localFunil.etapas = this.$store.getters.getConfigCrm.etapas.filter((option) => {
                return option.codfunil == this.localFunil.codfunil
            })

            this.negociocrm.codfunil = this.localFunil.codfunil
            this.negociocrm.codetapa = this.localFunil.etapas[0].codetapa
        }


    },

    watch: {

    },

    mounted () {
        this.setFields()

        this.$nextTick(function () {
            if (this.$refs.pessoa) {
                this.$refs.pessoa.focus()
            }
        })
        // this.handleAdicionarTelefone()
        // this.handleAdicionarEmail()
    },

    created () {
        if (this.funil) {
            this.localFunil = this.funil
            this.negociocrm.codetapa = this.funil.etapas[0].codetapa
            this.negociocrm.codfunil = this.funil.codfunil
        } 
        else 
          this.loadConfig()

        if (this.params) {
           if (this.params.negocio) 
              this.negociocrm = this.params.negocio
           if (this.params.pessoa) {
              this.negociocrm.codpessoa = this.params.pessoa.codpessoa
              this.negociocrm.pessoa = [ this.params.pessoa ]
           }
           if (this.params.organizacao) {
              this.negociocrm.codorg = this.params.organizacao.codpessoa
              this.negociocrm.organizacao = [ this.params.organizacao ]
           }
           if (this.params.lead) {
              //CRIA UM NEGOCIO ATRAVES DO LEAD
              this.pessoa.codorg = null
              this.pessoa.novo = true
              this.pessoa.nome = this.params.lead.pessoanome
              this.telefones = [ { numero: this.params.lead.fonenumero, tipofone: null } ]
              this.emails = [ { email: this.params.lead.email, tipoemail: null } ]
              this.organizacao.codorg = null
              this.organizacao.novo = true
              this.organizacao.nome = this.params.lead.orgnome
              this.negociocrm.codtag = this.params.lead.codtag
              this.negociocrm.valor = this.params.lead.valor
              this.negociocrm.titulo = this.params.lead.titulo
              this.negociocrm.codorigem = this.params.lead.codorigem
              this.negociocrm.codlead = this.params.lead.codlead
           }
        }

    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container" style="width: 600px; min-width: 500px; max-width: 100%">
            <div class="nb-modal-header">
                <div class="row">
                    <div class="col-md-12 col-12">
                        <h4 class="def-title"> {{ title }} </h4>
                    </div>
                </div>
            </div>
            <div class="nb-modal-scrollable-body">
                <!-- <label-title title="Contato" icon="fa-user"></label-title> -->
                <div class="row" v-if="isNovoNegocio || alterarPessoa">
                    <div class="col-md-12">
                        <input-search ref="pessoa" v-model="negociocrm.codpessoa" @novo="handleNovoPessoa" @select="handleSelectPessoa" :isSelect="true" :params="inputPessoa" :metadata="metadata.negociocrm.codpessoa"></input-search>
                    </div>
                </div>

                <!-- INCLUSAO DE NOVA PESSOA OBRIGA INFORMAR CONTATOS -->
                <div v-if="pessoa && pessoa.novo">
                    <!-- telefones -->
                    <div class="row pl-5">
                        <div class="col-12">
                            <v-label label="Telefone"></v-label>
                        </div>
                    </div>
                    <div>
                        <div class="row pl-5" v-for="(fone, index) in telefones" :key="index">
                            <div class="col-md-5">
                                <input-search :params="inputFone" v-model="fone.numero">
                                <!-- :name="'numero' + index" :v-errors="errors" v-validate="metadata.fonecrm.numero.validator"> -->
                                    <a v-if="index == telefones.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarTelefone">Adicionar Telefone</a>
                                </input-search>
                            </div>
                            <form-field v-model="fone.tipofone" type="select" col="4" 
                                :name="'tipofone' + index" :v-errors="errors" v-validate="metadata.fonecrm.tipofone.validator"></form-field>
                            <div class="col-auto">
                                <v-button v-if="telefones.length>1" icon="fa-trash" @click="handleDeleteTelefone(index)"></v-button>
                            </div>
                        </div>
                    </div>

                    <!-- emails -->
                    <div class="row pl-5">
                        <div class="col-12">
                            <v-label label="Email"></v-label>
                        </div>
                    </div>
                    <div>
                        <div class="row pl-5" v-for="(email, index) in emails" :key="index">
                            <div class="col-md-5">
                                <input-search :params="inputEmail" v-model="email.email">
                                <!-- :name="'email' + index" :v-errors="errors" v-validate="metadata.emailcrm.email.validator"> -->
                                <a v-if="index == telefones.length-1" style="cursor: pointer; color: #0091ea;" @click="handleAdicionarEmail">Adicionar Email</a>
                                </input-search>
                            </div>
                            <form-field v-model="email.tipoemail" type="select" col="4"
                                :name="'tipoemail' + index" :v-errors="errors" v-validate="metadata.emailcrm.tipoemail.validator"></form-field>
                            <div class="col-md-1 col-1">
                                <v-button v-if="emails.length>1" icon="fa-trash" @click="handleDeleteEmail(index)"></v-button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else>
                    <div class="row align-items-center" v-for="(fone, index) in telefones" :key="index">
                            <div class="col-md-5 pl-5">
                                <i class="fa fa-phone pr-2" aria-hidden="true"></i>
                                <span class="data-list"> {{ fone.numero | formatFone }} </span>
                                <span class="data-list"> {{ fone.tipofone | getTextOption(metadata.fonecrm.tipofone) }} </span>
                            </div>
                    </div>
                    <!-- emails -->
                    <div class="row align-items-center mb-1" v-for="(email, index) in emails" :key="index">
                            <div class="col-md-5 pl-5">
                                <i class="fa fa-envelope pr-2" aria-hidden="true"></i>
                                <span class="data-list"> {{ email.email }} </span>
                                <!-- <span class="data-list"> {{ email.tipoemail | getTextOption(metadata.emailcrm.tipoemail) }} </span> -->
                            </div>
                    </div>
                </div>

                <!-- ORGANIZACAO -->
                <div class="row" v-if="isNovoNegocio || alterarOrg">
                    <div class="col-md-12">
                        <input-search ref="organizacao" v-model="negociocrm.codorg" @novo="handleNovoOrg" @select="handleSelectOrg" :isSelect="true" :params="inputOrg" :metadata="metadata.negociocrm.codorg"></input-search>
                    </div>
                </div>

                <div class="row" v-if="alterarOutrosCampos">
                    <form-field v-model="negociocrm.titulo" type="text" col="12" :metadata="metadata.negociocrm.titulo"
                        name="titulo" :v-errors="errors" v-validate="metadata.negociocrm.titulo.validator"></form-field>
                </div>

                <div class="row mb-3" v-if="localFunil && isNovoNegocio">
                    <div class="col-md-12 col-12">
                        <crm-pipeline @change="handleChangeEtapa" :negocio="negociocrm" :funil="localFunil" :negocio-novo-form="true"></crm-pipeline>
                    </div>
                </div>

                <div class="row" v-if="alterarOutrosCampos">
                    <div class="col-md-12 col-12">
                        <input-color ref="etiqueta" v-model="negociocrm.codtag" :params="{ edit: true, label: 'Etiqueta', url: 'crm/tag/list/negocio' }"  @editar="handleEditarTag" @adicionar="handleAdicionarTag"></input-color>
                    </div>
                </div>

                <div class="row" v-if="alterarOutrosCampos">
                    <form-field v-model="negociocrm.dataprevista" type="date" col="6" :metadata="metadata.negociocrm.dataprevista"
                        name="dataprevista" :v-errors="errors" v-validate="metadata.negociocrm.dataprevista.validator"></form-field>
                </div>
                <div class="row" v-if="alterarOutrosCampos">
                    <form-field v-model="negociocrm.valor" type="value" col="6" :metadata="metadata.negociocrm.valor" preaddon="R$"
                        name="valor" :v-errors="errors" v-validate="metadata.negociocrm.valor.validator"></form-field>
                </div>
                <div class="row" v-if="alterarOutrosCampos">
                    <form-field v-model="negociocrm.probabilidade" type="value" col="6" :metadata="metadata.negociocrm.probabilidade" addon="%"
                        name="probabilidade" :v-errors="errors" v-validate="metadata.negociocrm.probabilidade.validator"></form-field>
                </div>
                <div class="row mb-5" v-if="alterarOutrosCampos">
                    <form-field v-model="negociocrm.codorigem" type="select2" col="12" 
                        :metadata="metadata.negociocrm.codorigem">
                        <a v-if="administrador" style="cursor: pointer; color: #0091ea;" @click="handleCadastroOrigem">Acesso ao cadastro de origem</a>
                    </form-field>
                    <!-- <div class="col-md-12">
                        <input-search ref="origem" v-model="negociocrm.codorigem" @novo="handleNovoOrigem" @select="handleSelectOrigem" :params="inputOrigem" :metadata="metadata.negociocrm.codorigem"></input-search>
                    </div> -->
                </div>

            </div>
            <div class="modal-footer">
                        <v-button label="Cancelar" title="" icon="fa-arrow-left" @click="closeForm"></v-button>
                        <v-button label="Salvar" title="" :nb-btdef="true" @click="handleSalvar"></v-button>
            </div>
        </div>
        <crm-tag-form v-if="showTagForm" @closeform="handleCloseTag" tptag="N" :index="codtag" :crud="crudTag" ></crm-tag-form>
    </div>

</template>

<style>

</style>


// WEBPACK FOOTER //
// src/forms-crm/crm-negocio-novo-form.vue